export const TASK_TITLE = "Task Management"
export const NOT_ASSIGNED = "Not Assigned";
export const SITESTAFF = "SITESTAFF";

export const SUCCESS = {
  TASK_CREATED: "Task created successfully!",
  UPDATE_STATUS: "Status Updated Successfully!",
  COMMENT: "Comment Submitted!",
  DELETION_DONE: "Task deleted Successfully!",
  DOWNLOAD_SUCCESSFUL: "File download Completed Successfully", 
  UPLOAD_SUCCESSFUL: "File Uploaded Successfully",
};

export const ERROR = {
  DATA:"Failed to fetch data!",
  SITE: "Error while fetching sites data",
  TASK: "Failed to create task!",
  TASK_DETAILS: "Failed to fetch task details!",
  COMMENT: "Failed to Submit Comment",
  UPDATE_STATUS: "Failed to update status!",
  DELETE_NOT_DONE: "Failed to delete task",
  DOWNLOAD_NOT_SUCCESSFUL: "Unable to download file",
  UPLOAD_UNSUCCESSFUL: "File was not uploaded",
  USER_FETCH_FAILED: "Failed to fetch users"
};

export const STATUS = {
 PENDING:"PENDING",
 COMPLETED:"COMPLETED",
 IN_PROGRESS:"IN_PROGRESS",
 CANCELLED:"CANCELLED",
  CLOSED: "CLOSED",
  PENDING_L1_APPROVAL: "PENDING_L1_APPROVAL",
  PENDING_L2_APPROVAL: "PENDING_L2_APPROVAL",
  
}
 
export const REQUIRED = {
 TITLE:"Title is required!",
 DESCRIPTION:"Description is required!",
 START_DATE:"Start date is required!",
 ESTIMATED_END_DATE:"Estimated end date is required!",
 ASSIGNEE:"Assignee is required!",
 SITE:"Site is required!",
 DELETE_CONFIRMATION: "Are you sure you want to delete this task?",
}

export const TASK_STATUS = [
  { value: 'PENDING', label: 'Pending' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'CANCELLED', label: 'Cancelled' },
  { value: 'CLOSED', label: 'Closed' },
];

export const DEFAULT_STATUS_OPTIONS = [
  { label: "All", value: "" },
  { label: "Pending", value: "PENDING" },
  { label: "In Progress", value: "IN_PROGRESS" },
  { label: "pending  L1 Approval", value: "PENDING_L1_APPROVAL"},
  { label: "pending  L2 Approval", value: "PENDING_L2_APPROVAL"},
  {label:"Closed", value:"CLOSED"}
];

export const ROLES={
  SITE_STAFF: "SITESTAFF",
  INCHARGE: "INCHARGE",
  PROJECT_INCHARGE: "PROJECT_INCHARGE",
  ADMIN: "ADMIN",
  DIRECTOR_MANAGEMENT: "DIRECTOR_MANAGEMENT",
}